import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Button from '../Button';

import styles from './planCard.module.scss';

const PlanCard = ({
  planId,
  image,
  logo,
  currency,
  price,
  temporality,
  taxText,
  promotionText1,
  promotionText2,
  promotionText3,
  whatIncludesText1,
  whatIncludesText2,
  whatIncludesColor,
  contractText1,
  contractText2,
  contractText1color,
  contractText2color,
  contractButtonColor,
  onWhatIncludesClicked,
  onContractClicked,
  className,
  children,
} = props) => {
  const textRender = (text, styles = {}) => {
    return text ? (
      <p style={{ margin: 0, ...styles }}>{text}</p>
    ) : (
      <p style={{ margin: 0, height: '16px' }} />
    );
  };

  return (
    <div id={planId} className={classNames(styles.wrapper, className)}>
      <div
        className={styles.container}
        style={{ backgroundImage: `url(${image})` }}
      >
        <div className={styles.logoContainer}>
          {logo ? (
            <img src={logo} alt="logo" />
          ) : (
            <div className={styles.logo} />
          )}
        </div>

        <div className={styles.priceContainer}>
          <div className={styles.price}>
            <div>
              <p>{currency}</p>
            </div>
            <div>
              <p>{price}</p>
            </div>
            <div className={styles.temporalityContainer}>
              <p className={styles.temporality}>{temporality}</p>
            </div>
          </div>
        </div>

        <div className={styles.taxContainer}>
          <p className={styles.tax}>{taxText}</p>
        </div>
        <div className={styles.promotionTexts}>
          <div className={styles.promotionText}>{promotionText1}</div>
          <div className={styles.promotionText}>{promotionText2}</div>
          <div className={styles.promotionText}>{promotionText3}</div>
        </div>

        {whatIncludesText1 || whatIncludesText2 ? (
          <Button
            type="whatIncludes"
            onClick={onWhatIncludesClicked}
            className={styles.whatIncludesBtn}
            style={{
              backgroundColor: whatIncludesColor,
            }}
          >
            {textRender(whatIncludesText1)}
            {textRender(whatIncludesText2)}
          </Button>
        ) : (
          <div className={styles.whatIncludesBtn} />
        )}

        {contractText1 || contractText2 ? (
          <Button
            type="red"
            onClick={onContractClicked}
            className={styles.contractBtn}
            style={{
              backgroundColor: contractButtonColor,
            }}
          >
            <div style={{ display: 'block' }}>
              {textRender(contractText1, {
                color: contractText1color,
              })}
              {textRender(contractText2, {
                color: contractText2color,
              })}
            </div>
          </Button>
        ) : (
          <div className={styles.contractBtn} />
        )}

        {children}
      </div>
    </div>
  );
};

PlanCard.propTypes = {
  planId: PropTypes.string,
  image: PropTypes.string,
  logo: PropTypes.string,
  currency: PropTypes.string,
  price: PropTypes.string,
  temporality: PropTypes.string,
  taxText: PropTypes.string,
  promotionText1: PropTypes.string,
  promotionText2: PropTypes.string,
  promotionText3: PropTypes.string,
  whatIncludesText1: PropTypes.string,
  whatIncludesText2: PropTypes.string,
  whatIncludesColor: PropTypes.string,
  contractText1: PropTypes.string,
  contractText2: PropTypes.string,
  contractText1color: PropTypes.string,
  contractText2color: PropTypes.string,
  contractButtonColor: PropTypes.string,
  onWhatIncludesClicked: PropTypes.func,
  onContractClicked: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default PlanCard;
